module.exports = __webpack_public_path__ + "static/media/IMG_0938.918b6a97.JPG";